import { Box, BoxProps, Stack, styled } from "@mui/material"
import { ComponentType } from "react"
import { ImageStylings } from "./Image"

type ImageContainerProps = BoxProps & {
    imageStylings?: ImageStylings
}
export const ImageContainer = styled(Box, { shouldForwardProp: (prop: string) => !["imageStylings"].includes(prop) })<ImageContainerProps>(
    ({ theme, imageStylings }) => ({
        boxSizing: "border-box",
        border: `1px solid transparent`,
        backgroundColor: theme.palette.background.default,
        boxShadow: theme.shadows[2],
        width: imageStylings ? imageStylings.size : undefined,
        height: imageStylings ? imageStylings.size : undefined,
        zIndex: 2,
        marginTop: imageStylings ? `${imageStylings.marginTop}px` : undefined,
        "&[data-clickable]:hover": {
            borderColor: `${theme.palette.primary.main}`,
            cursor: "pointer",
        },
        img: {
            objectFit: "contain",
        },
        textAlign: "center",
        alignContent: "center",
    })
) as ComponentType<ImageContainerProps>

export const TileWrapper = styled(Stack)(({ theme }) => ({
    height: "100%",
    justifyContent: "space-between",
    padding: "0.5em",
    borderRadius: 3,
    border: "1px solid transparent",
    "&.expanded": {
        minHeight: 460,
        borderColor: theme.palette.primary.main,
        boxShadow: theme.shadows[3],
    },
}))
